import { getBreadcrumbLabel } from './client-store';

const REDIRECT_PATH_KEY = 'redirect_path';

export const REDIRECT_PATH_LABEL_KEY = 'redirect_path_label';

function buildRedirectPathQueryParams() {
  const { search, pathname } = window.location;

  const breadcrumbLabelRaw = getBreadcrumbLabel();
  const breadcrumbLabelEncoded = encodeURIComponent(breadcrumbLabelRaw || '');

  const redirectPath = encodeURIComponent(`${pathname}${search}`);

  if (breadcrumbLabelEncoded) {
    return `${REDIRECT_PATH_KEY}=${redirectPath}&${REDIRECT_PATH_LABEL_KEY}=${breadcrumbLabelEncoded}`;
  }

  return `${REDIRECT_PATH_KEY}=${redirectPath}`;
}

export function redirectToLogin() {
  if (!isProtectedRoute()) {
    return;
  }

  const redirectPathQueryParams = buildRedirectPathQueryParams();

  window.location.href = `/works/sign_in?${redirectPathQueryParams}`;
}

function isProtectedRoute() {
  return (
    window.location.pathname !== '/works/sign_in' &&
    window.location.pathname !== '/works/auth/forgot-password' &&
    window.location.pathname.indexOf('/works/auth/failure') < 0 &&
    window.location.pathname.indexOf('/works/auth/reset-password') < 0 &&
    window.location.pathname.indexOf('/works/auth/activate-account') < 0
  );
}
